<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
        <el-form size="small" :model="form" :rules="formRules" :label-width="formLabelWidth" ref="form">
            <el-form-item label="标题" prop="name">
                <el-input v-model="form.name" placeholder="标题" clearable/>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input v-model.number="form.sort" autocomplete="off"></el-input>
                <div class="tips">越小越靠前</div>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
        <!--上传图片组件-->
<!--        <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>-->
    </el-dialog>
</template>

<script>
    import { wishCategoryEdit } from '@/api/education';
    // import Upload from '@/components/file/Upload';

    export default {
        components: {
            // Upload
        },
        data() {
            return {
                title: '',
                form: {
                    category_id: '',
                    name: '',
                    sort: 0
                },
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                /*链接选择*/
                is_linkset: false,
                // 验证
                formRules: {
                    title: [{
                        required: true,
                        message: '请输入广告名称',
                        trigger: 'blur'
                    }]
                },
                /*上传图片*/
                isupload: false,

            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.title = '添加分类'
                } else {
                    this.title = '编辑分类'
                    this.form.category_id = row.category_id
                    this.form.name = row.name
                    this.form.sort = row.sort
                    // this.getDetail()
                }
                this.dialogFormVisible = true
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.dialogFormVisible = false
            },
            // 保存
            save() {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.submit_loading = true
                        wishCategoryEdit(this.form).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.$emit('fetch-data')
                            this.submit_loading = false
                            this.close()
                        }).catch(()=>{
                            this.submit_loading = false
                        })
                    }
                })
            },
            // getDetail(){
            //     questionDetail({id: this.form.question_id}).then((result)=>{
            //         this.form = Object.assign({}, result.data)
            //         this.options = result.data.option
            //     })
            // },

            // 图片上传
            openUpload(e) {
                // this.type = e;
                this.isupload = true;
            },
            /*获取图片*/
            returnImgsFunc(e) {
                if (e != null && e.length > 0) {
                    this.file_path = e[0].file_path;
                    this.form.image_id = e[0].file_id;
                }
                this.isupload = false;
            },
        }
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/education/wish/category/edit.vue